import { IPurchaseAddEditRequest } from '../../../../model/scp/purchase/request/purchase-add-edit-request';
import { ITableResponse } from '../../../../model/scp/purchase/response/tables-response';
import { IUnidEntityResponse } from '../../../../model/scp/entity/response/unid-entity-response';
import { IPurchaseItemResponse } from '../../../../model/scp/purchase/response/purchase-item-response';
import { IFileResponse } from '../../../../model/scp/base/response/file-response';

export type PurchaseCreateEditState = {
  file?: File;
  tabIndex1: number;
  tabIndex2: number;
  purchaseRequest: IPurchaseAddEditRequest;
  modality: ITableResponse[];
  disputeMode: ITableResponse[];
  instrumentSummons: ITableResponse[];
  legalSupport: ITableResponse[];
  typeDocument: ITableResponse[];
  unidEntity: IUnidEntityResponse[];
  itemsPurchaseJson: string;
  purchaseId?: number;
  showValidationErrors: boolean;
  purchaseItems: IPurchaseItemResponse[];
  purchaseFiles: IFileResponse[];
};

export enum ACTION_TYPES {
  setFile = 'setFile',
  setTabIndex1 = 'setTabIndex1',
  setTabIndex2 = 'setTabIndex2',
  setPurchaseRequest = 'setPurchaseRequest',
  setModality = 'setModality',
  setDisputeMode = 'setDisputeMode',
  setInstrumentSummons = 'setInstrumentSummons',
  setLegalSupport = 'setLegalSupport',
  setTypeDocument = 'setTypeDocument',
  setUnidEntity = 'setUnidEntity',
  setItemsPurchaseJson = 'setItemsPurchaseJson',
  setShowValidationErrors = 'setShowValidationErrors',
  setPurchaseItems = 'setPurchaseItems',
  setPurchaseFiles = 'setPurchaseFiles',
}

export const PurchaseCreateEditReducer = (state: PurchaseCreateEditState, action: any): PurchaseCreateEditState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setFile:
      return { ...state, file: payload };
    case ACTION_TYPES.setTabIndex1:
      return { ...state, tabIndex1: payload };
    case ACTION_TYPES.setTabIndex2:
      return { ...state, tabIndex2: payload };
    case ACTION_TYPES.setPurchaseRequest:
      return { ...state, purchaseRequest: { ...state.purchaseRequest, ...payload } };
    case ACTION_TYPES.setModality:
      return { ...state, modality: payload };
    case ACTION_TYPES.setDisputeMode:
      return { ...state, disputeMode: payload };
    case ACTION_TYPES.setInstrumentSummons:
      return { ...state, instrumentSummons: payload };
    case ACTION_TYPES.setLegalSupport:
      return { ...state, legalSupport: payload };
    case ACTION_TYPES.setTypeDocument:
      return { ...state, typeDocument: payload };
    case ACTION_TYPES.setUnidEntity:
      return { ...state, unidEntity: payload };
    case ACTION_TYPES.setItemsPurchaseJson:
      return { ...state, itemsPurchaseJson: payload };
    case ACTION_TYPES.setShowValidationErrors:
      return { ...state, showValidationErrors: payload };
    case ACTION_TYPES.setPurchaseItems:
      return { ...state, purchaseItems: payload };
    case ACTION_TYPES.setPurchaseFiles:
      return { ...state, purchaseFiles: payload };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}
